import apiRequest from './apiRequest';

const officeLocationApi = {
    async getOfficeLocations(businessInfoId, token) {
        const url = `/api/accounts/business-information/office-locations?businessInfoId=${businessInfoId}`;
        return apiRequest(url, 'GET', token);
    },

    async createOfficeLocation(businessInfoId, locationData, token) {
        const url = `/api/accounts/business-information/office-locations?businessInfoId=${businessInfoId}`;
        return apiRequest(url, 'POST', token, locationData);
    },

    async updateOfficeLocation(locationId, locationData, token) {
        const url = `/api/accounts/business-information/office-locations/${locationId}`;
        return apiRequest(url, 'PUT', token, locationData);
    },

    async deleteOfficeLocation(locationId, token) {
        const url = `/api/accounts/business-information/office-locations/${locationId}`;
        return apiRequest(url, 'DELETE', token);
    }
};

export default officeLocationApi;
